import { render, staticRenderFns } from "./Deals.vue?vue&type=template&id=55102f1a&scoped=true&"
import script from "./Deals.vue?vue&type=script&lang=ts&"
export * from "./Deals.vue?vue&type=script&lang=ts&"
import style0 from "./Deals.vue?vue&type=style&index=0&id=55102f1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55102f1a",
  null
  
)

export default component.exports